import Consumption from './Consumption';

export default Consumption;